import { SVGProps } from 'react';

const ChartScatter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 3v16a2 2 0 0 0 2 2h16M7.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m11-2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-7 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-4 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m10-2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    />
  </svg>
);
export default ChartScatter;
